import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as SonnerToaster } from "sonner";
/**
 * Pre-styled Sonner Toaster using Obsidian Bloom tokens.
 * Mount once in App.tsx.
 */
export function Toaster() {
    return (_jsx(SonnerToaster, { position: "top-right", toastOptions: {
            classNames: {
                toast: "rounded-modal border border-border-subtle shadow-elevated text-sm font-medium bg-surface-2",
                title: "font-display font-semibold italic text-text",
                description: "text-text-muted",
                success: "border-l-4 border-l-status-success",
                error: "border-l-4 border-l-status-danger",
                info: "border-l-4 border-l-status-info",
            },
        } }));
}
